namespace Teva {
    export class HebrewDateHelpers {
        public static DaysInMonth(Month: number, Year: number): number {
            return 30 - ((Month == 8 ||
                Month == 10 ||
                Month == 12 ||
                Month == 3 ||
                Month == 6 ||
                (Month == 5 && !HebrewDateHelpers.IsLeapYear(Year)) ||
                (Month == 1 && !HebrewDateHelpers.IsLongCheshvan(Year)) ||
                (Month == 2 && HebrewDateHelpers.IsShortKislev(Year))) ? 1 : 0);
        }
        public static DaysInYear(Year) {
            return HebrewDateHelpers.HebrewElapsedDays(Year + 1) - HebrewDateHelpers.HebrewElapsedDays(Year);
        }
        private static IsLongCheshvan(Year) {
            return (HebrewDateHelpers.DaysInYear(Year) % 10) == 5;
        }
        private static IsShortKislev(Year) {
            return (HebrewDateHelpers.DaysInYear(Year) % 10) == 3;
        }
        public static HebrewElapsedDays(Year) {
            // borrowed from original JS
            var m_elapsed = 235 * Math.floor((Year - 1) / 19) +
                12 * ((Year - 1) % 19) +
                Math.floor(((((Year - 1) % 19) * 7) + 1) / 19);

            var p_elapsed = 204 + (793 * (m_elapsed % 1080));

            var h_elapsed = 5 + (12 * m_elapsed) +
                793 * Math.floor(m_elapsed / 1080) +
                Math.floor(p_elapsed / 1080);

            var parts = (p_elapsed % 1080) + 1080 * (h_elapsed % 24);

            var day = 1 + 29 * m_elapsed + Math.floor(h_elapsed / 24);
            var alt_day = day + ((((parts >= 19440) ||
                ((2 == (day % 7)) && (parts >= 9924) && !(HebrewDateHelpers.IsLeapYear(Year))) ||
                ((1 == (day % 7)) && (parts >= 16789) && HebrewDateHelpers.IsLeapYear(Year - 1)))) ? 1 : 0);

            return alt_day + (((alt_day % 7) === 0 ||
                (alt_day % 7) == 3 ||
                (alt_day % 7) == 5) ? 1 : 0);
        }
        public static IsLeapYear(Year) {
            return ((1 + Year * 7) % 19) < 7;
        }
        public static MonthNames(Year) {
            if (HebrewDateHelpers.IsLeapYear(Year))
                return ["תשרי", "חשוון", "כסלו", "טבת", "שבט", "אדר א'", "אדר ב'", "ניסן", "אייר", "סיוון", "תמוז", "אב", "אלול"];
            else
                return ["תשרי", "חשוון", "כסלו", "טבת", "שבט", "אדר א'", "ניסן", "אייר", "סיוון", "תמוז", "אב", "אלול"];
        }
        public static MonthDayNames() {
            return ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'", "ח'", "ט'", "י'", "י\"א", "י\"ב", "י\"ג", "י\"ד", "ט\"ו", "ט\"ז", "י\"ז", "י\"ח", "י\"ט", "כ'", "כ\"א", "כ\"ב", "כ\"ג", "כ\"ד", "כ\"ה", "כ\"ו", "כ\"ז", "כ\"ח", "כ\"ט", "ל'"]
        }
    }
}
